import React from 'react';
import { /*makeStyles,*/ IconButton } from '@material-ui/core';

const AfitdIconButton = props => {
    const { isHidden, children, ...otherProps } = props;
    // const classes = useStyles();

    if (isHidden) {
        return null;
    } else {
        return <IconButton {...otherProps}>{children}</IconButton>;
    }
};

export default AfitdIconButton;
